import RouterProvider from './router';
import './index.css';

function App() {
  return <RouterProvider />;
}

export default App;
